import { render, staticRenderFns } from "./CompanyUsersListPage.vue?vue&type=template&id=a48044d0&scoped=true"
import script from "./CompanyUsersListPage.vue?vue&type=script&lang=js"
export * from "./CompanyUsersListPage.vue?vue&type=script&lang=js"
import style0 from "./CompanyUsersListPage.vue?vue&type=style&index=0&id=a48044d0&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a48044d0",
  null
  
)

export default component.exports